import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '', children: [
      {
        path: '', 
        loadComponent: () => import('./public-login.component').then(m => m.PublicLoginComponent),
        data: {
          title: 'KudosHub | Login',
          description:'Already an existing user? Log into your KudosHub account and start validating your email list. Click on Forgot Password to set a new password.',
          keywords: 'kudoshub login',
          ogTitle: 'KudosHub | Login',
          ogDesc: 'Kudoshub login page.',
          ogImage: 'https://kudoshub.com/theme/images/og-images/login-img01.webp',
          ogUrl: 'https://kudoshub.com/login',
          twitterTitle: 'KudosHub | Login',
          twitterDesc: 'Kudoshub login page.',
          twitterImage: 'https://kudoshub.com/theme/images/og-images/login-img01.webp'
        }
      }
    ]
  }
];
